import type { PagedResultDto } from "@services/dto/pagedResultDto"
import floorService from "@services/master-data/floorService"

import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class FloorStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await floorService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.getListFloor()
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await floorService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
    appDataStore.getListFloor()
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await floorService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await floorService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async exportExcel(params: any) {
    this.isLoading = true
    return await floorService
      .exportExcel(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await floorService
        .importFloor(file)
        .finally(() => (this.isLoading = false))

      appDataStore.getListFloor()
      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
  @action
  async exportTemplateFloor() {
    this.isLoading = true
    return await floorService
      .exportTemplateFloor()
      .finally(() => (this.isLoading = false))
  }
}

export default FloorStore
